import _default from './Divider';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Divider/index.js
// module id = 3257
// module chunks = 0